var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AI container"},[_c('ReAiNavigate'),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/data/ai/prompts/0"}},[_vm._v("Добавить")]),_vm._l((_vm.ApiData),function(p){return _c('REAIPrompt',{key:p.id,attrs:{"prompt":p}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }